
// 卡券组件
import CouponItem from '@/components/CouponItem'
// 分页组件
import GoodsListPage from '@/components/GoodsListPage'

// 查询参数对应的status
const StatusList = {
    WAIT_USE: 0,
    USED: 1,
    INVALID: 2
}
export default {
    name: 'coupon',
    components: {
        CouponItem,
        GoodsListPage
    },
    data() {
        return {
            loading: false,
            pageInfo: {
                page: 1,
                pageSize: 20,
                total: 0
            },
            activeNav: 'WAIT_USE',
            navList: [
                {
                    label: '待使用',
                    status: 'WAIT_USE',
                    count: 0
                },
                {
                    label: '已使用',
                    status: 'USED',
                    count: 0
                },
                {
                    label: '已失效',
                    status: 'INVALID',
                    count: 0
                }
            ],
            couponList: [], //优惠卷列表
            typaTabs: [
                { label: '包赔券', name: 1, count: 0 },
                { label: '订单券', name: 2, count: 0 },
                { label: '曝光券', name: 3, count: 0 },
            ],
            activeTab: 1,
        }
    },
    mounted() {
        this.activeNav = this.$route.query?.status || 'WAIT_USE'
        this.getCouponCount()
        this.getCouponList()
    },
    destroyed() {
        // 清除券包红点
        this.clearNewCouponDot()
    },
    watch: {
        /**
         * 监听二级导航
         */
        activeTab: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getCouponList()
                }
            },
        },
        /**
         * 监听一级导航
         */
        activeNav: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.getCouponGroupCount()
                }
            },
            immediate: true
        },
    },
    methods: {
        async getCouponGroupCount() {
            try {
                const data = {
                    couponsStatus: StatusList[this.activeNav]
                }
                const res = await this.$api.couponGroupCount(data)
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                const { compensationTotal, exposureTotal, orderTotal } = res.data
                this.typaTabs[0].count = compensationTotal
                this.typaTabs[1].count = orderTotal
                this.typaTabs[2].count = exposureTotal
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        // 点击卡券种类
        handleChangeNav(item) {
            this.activeNav = item.status
            this.getCouponCount()
            this.getCouponList()
            this.couponList = []
            this.$router.push({
                path: '/account/coupon',
                query: {
                    status: item.status
                }
            })
        },
        // 获取优惠券分组数量
        getCouponCount() {
            const couponsStatus = StatusList[this.activeNav] || StatusList.WAIT_USE
            this.$api.getMyActivityCouponCount({ couponsStatus }).then(({ success, data }) => {
                if (success) {
                    this.navList[0].count = data?.unuseCount // 待使用
                    this.navList[1].count = data?.usedCount // 已使用
                    this.navList[2].count = data?.expiredCount // 已失效
                } else {
                    this.navList[0].count = 0
                    this.navList[1].count = 0
                    this.navList[2].count = 0
                }
            })
        },
        // 获取优惠券列表
        getCouponList() {
            const couponsStatus = StatusList[this.activeNav] || StatusList.WAIT_USE
            const _prams = {
                action: {
                    couponsStatus,
                    scopeBusiness: this.activeTab
                },
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.loading = true
            this.$api
                .getMyActivityCouponList(_prams)
                .then(({ success, data }) => {
                    if (success) {
                        this.couponList = data?.records || []
                        this.pageInfo.page = data?.page || 1
                        this.pageInfo.total = Number(data?.total) || 0
                    } else {
                        this.couponList = []
                        this.pageInfo.page = 1
                        this.pageInfo.total = 0
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 分页
        handleCurrentChange(page) {
            this.pageInfo.page = page
            this.getCouponList()
        },
        // 清除券包红点
        clearNewCouponDot() {
            this.$api.clearUserCenterNewCouponApi().then(res => {
                if (res.success) {
                    this.$store.dispatch('user/UserCenterCouponDot')
                }
            })
        }
    }
}
